import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const FamilyIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M8.89331 7.99185C9.44935 7.43314 10.3154 7.01071 11.625 7.01071C14.525 7.01071 15.25 9.08214 15.25 10.1179V17.8143H10.5893M7.10669 7.99185C6.55065 7.43314 5.6846 7.01071 4.375 7.01071C1.475 7.01071 0.75 9.08214 0.75 10.1179V17.8143H5.41071M5.41071 17.8143H10.5893M5.41071 17.8143V13.7429C5.41071 12.7071 6.34848 11.1536 8 11.1536M8 11.1536C8.85801 11.1536 9.55357 10.458 9.55357 9.6C9.55357 8.74198 8.85801 8.04643 8 8.04643C7.14199 8.04643 6.44643 8.74198 6.44643 9.6C6.44643 10.458 7.14199 11.1536 8 11.1536ZM8 11.1536C9.7519 11.1536 10.5893 12.7071 10.5893 13.7429V17.8143M14.2143 4.68036C14.2143 5.96738 13.1709 7.01071 11.8839 7.01071C10.5969 7.01071 9.55357 5.96738 9.55357 4.68036C9.55357 3.39333 10.5969 2.35 11.8839 2.35C13.1709 2.35 14.2143 3.39333 14.2143 4.68036ZM6.44643 4.68036C6.44643 5.96738 5.40309 7.01071 4.11607 7.01071C2.82905 7.01071 1.78571 5.96738 1.78571 4.68036C1.78571 3.39333 2.82905 2.35 4.11607 2.35C5.40309 2.35 6.44643 3.39333 6.44643 4.68036Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
